// Test-data tool (staging/dev only) — force-activate the testcaregiver+*@ accounts.
// POST /api/v1/admin/caregivers/activate-test-accounts
import { z } from 'zod';
export const ActivateTestCaregiversRequestShape = z.object({
    /** Default true — preview what would change, write nothing. Set false to apply. */
    dryRun: z.boolean().default(true),
});
export const ActivateTestCaregiverResultShape = z.object({
    email: z.string(),
    roleCodes: z.array(z.string()),
    alreadyActive: z.boolean(),
    credentialsSeeded: z.array(z.string()),
    complianceSeeded: z.array(z.string()),
    bankingSinSeeded: z.boolean(),
    icAcceptanceSeeded: z.boolean(),
    activated: z.boolean(),
});
export const ActivateTestCaregiversResponseShape = z.object({
    environment: z.string(),
    dryRun: z.boolean(),
    total: z.number().int().nonnegative(),
    results: z.array(ActivateTestCaregiverResultShape),
});
//# sourceMappingURL=test-data.schema.js.map